import { ref } from 'vue'
import { defineStore } from 'pinia'

/**
 * 认证会话内的一次性状态（V1.4 §6A）。
 *
 * 目前只装一件事：**「资料无误，继续」确认卡每人每会话只弹一次**。
 * 授权代表替三位董事挨个拉起 SDK 时，每次都让他重看一遍同样的 7 行登记资料，
 * 第二次起就变成了纯粹的点击噪音——而这张卡的价值恰恰在第一次（拍证件之前发现资料不对，
 * 比拍完之后走人工复核便宜得多）。
 *
 * 只活在内存里：刷新页面就重置，重新确认一次没有坏处。
 */
export const useKycStore = defineStore('kyc', () => {
  /** 本会话已确认过的主体（`self` 代表登录人自己，其余是 personId） */
  const confirmed = ref<Set<string>>(new Set())

  function key(personId: number | null): string {
    return personId == null ? 'self' : String(personId)
  }

  function isConfirmed(personId: number | null): boolean {
    return confirmed.value.has(key(personId))
  }

  function markConfirmed(personId: number | null) {
    const next = new Set(confirmed.value)
    next.add(key(personId))
    confirmed.value = next
  }

  function reset() {
    confirmed.value = new Set()
  }

  return { confirmed, isConfirmed, markConfirmed, reset }
})
